












import { Vue, Component } from 'vue-property-decorator'
import { components } from 'aws-amplify-vue'

import { $auth } from '@/services/Auth'

import Navbar from '@/components/Navbar.vue'

@Component({ components: { Navbar, ...components } })
export default class App extends Vue {
	get authenticated() {
		return $auth.authenticated
	}
}
